/**
 * Analytics Event Names and Property Keys
 * 
 * Naming Conventions:
 * - Events: "Object Action" format in Title Case (e.g., "Project Created")
 * - Properties: snake_case (e.g., wizard_type, watts_consumed)
 */

// ============================================
// EVENT NAMES
// ============================================

export const ANALYTICS_EVENTS = {
  // User Lifecycle
  USER_REGISTERED: 'User Registered',
  USER_LOGGED_IN: 'User Logged In',
  USER_LOGGED_OUT: 'User Logged Out',
  PROFILE_UPDATED: 'Profile Updated',
  
  // Project Management
  PROJECT_CREATED: 'Project Created',
  PROJECT_OPENED: 'Project Opened',
  PROJECT_DELETED: 'Project Deleted',
  COLLABORATOR_INVITED: 'Collaborator Invited',
  COLLABORATION_ACCEPTED: 'Collaboration Accepted',
  
  // Wizard Engagement
  WIZARD_STARTED: 'Wizard Started',
  WIZARD_STEP_COMPLETED: 'Wizard Step Completed',
  WIZARD_COMPLETED: 'Wizard Completed',
  WIZARD_ABANDONED: 'Wizard Abandoned',
  WIZARD_STEP_BACK: 'Wizard Step Back',
  
  // AI Features
  AI_FEATURE_USED: 'AI Feature Used',
  WATTS_BALANCE_CHANGED: 'Watts Balance Changed',
  WATTS_DEPLETED: 'Watts Depleted',
  WATTS_PURCHASED: 'Watts Purchased',
  AI_OPERATION_FAILED: 'AI Operation Failed',
  
  // Task Management
  TASK_CREATED: 'Task Created',
  TASK_MOVED: 'Task Moved',
  TASK_COMPLETED: 'Task Completed',
  TASK_DELETED: 'Task Deleted',
  TASK_ASSIGNED: 'Task Assigned',
  
  // Conversion & Monetization
  PRICING_VIEWED: 'Pricing Viewed',
  UPGRADE_STARTED: 'Upgrade Started',
  UPGRADE_COMPLETED: 'Upgrade Completed',
  UPGRADE_CANCELLED: 'Upgrade Cancelled',
  PLAN_DOWNGRADED: 'Plan Downgraded',
  
  // Session & Engagement
  SESSION_STARTED: 'Session Started',
  SESSION_ENDED: 'Session Ended',
  NAVIGATION: 'Navigation',
  SEARCH_PERFORMED: 'Search Performed',
  ERROR_ENCOUNTERED: 'Error Encountered'
}

// ============================================
// USER PROPERTY KEYS
// ============================================

export const USER_PROPERTIES = {
  EMAIL: 'email',
  PLAN_TYPE: 'plan_type',
  REGISTRATION_DATE: 'registration_date',
  TOTAL_PROJECTS: 'total_projects',
  TOTAL_WATTS_CONSUMED: 'total_watts_consumed',
  CURRENT_WATTS_BALANCE: 'current_watts_balance',
  WIZARDS_COMPLETED: 'wizards_completed',
  TASKS_COMPLETED: 'tasks_completed',
  LAST_LOGIN: 'last_login',
  LAST_PROJECT_ID: 'last_project_id'
}

// ============================================
// SUPER PROPERTY KEYS
// ============================================
// Super properties are automatically included with all events

export const SUPER_PROPERTIES = {
  PLAN_TYPE: 'plan_type',
  CURRENT_PROJECT_ID: 'current_project_id'
}
